module.exports = "void main() {\ngl_Position = vec4(0.0, 0.0, 0.0, 1.0);\n}"